<template>
    <div>

        <div class="py-4">
            <div class="loader text-center">
                <div class="spinner">
                    <div class="lds-grid">
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                        <div></div><div></div><div></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import * as nativeBridge from '@/native-bridge'

export default {
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Logout')

        if (!nativeBridge.post({ type: 'logout' })) {
            console.error('Native host bridge not found; cannot signal logout.')
        }
    },
}
</script>
